"use client";
import t, { useRef as n } from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import s from "./index.es49.js";
import b from "./index.es51.js";
const q = ({
  name: o,
  /* description, // maybe we will use this???*/
  shortDescription: l,
  slug: p,
  summary: r,
  categories: a,
  hash: c
}) => {
  const i = n(null);
  s(i, c);
  const e = r.page;
  return /* @__PURE__ */ t.createElement("div", { ref: i }, /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small bl-m-b-7" }, /* @__PURE__ */ t.createElement("div", { className: "bl-tile bl-tile--tertiary bl-text-center" }, /* @__PURE__ */ t.createElement("h1", { className: "bl-size-2 bl-p-b-3" }, o, " "), /* @__PURE__ */ t.createElement("div", { className: "bl-p-b-4" }, l), e.slug && (r.linkText || e.title) && /* @__PURE__ */ t.createElement(
    "a",
    {
      href: `/${process.env.NEXT_PUBLIC_STATS_BASE_URL}/${p}/${e.slug}`
    },
    r.linkText || e.title
  ))), a.map((m) => /* @__PURE__ */ t.createElement(b, { key: `category${m.title}`, ...m })));
};
export {
  q as default
};
//# sourceMappingURL=index.es3.js.map
